var _excluded = ["Card", "useCardTemplate"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { VStack } from '..';
import { DataTableWithFilters } from '../data-table-with-filters';
import { useIsMobile } from '../../hooks';
export var ResponsiveDataTable = _ref => {
  var {
      Card,
      useCardTemplate
    } = _ref,
    tableProps = _objectWithoutProperties(_ref, _excluded);
  var renderMobileCards = _ref2 => {
    var {
      rows,
      prepareRow
    } = _ref2;
    return /*#__PURE__*/React.createElement(VStack, {
      width: "100%"
    }, rows.map(row => {
      prepareRow(row);
      return Card(row.original);
    }));
  };
  var isMobile = useIsMobile();
  var {
    enableInfiniteScroll
  } = tableProps;
  var useCards = useCardTemplate || isMobile;
  return /*#__PURE__*/React.createElement(DataTableWithFilters, _extends({}, tableProps, {
    enableInfiniteScroll: enableInfiniteScroll && useCards,
    render: useCards ? renderMobileCards : undefined
  }));
};